export const BASE_URL = import.meta.env.VITE_APP_ME_POS_URL;
export const iconTintFilter =
  "brightness(0) saturate(100%) invert(93%) sepia(12%) saturate(700%)" +
  " hue-rotate(210deg) brightness(96%) contrast(87%)";
export const IS_PROD = import.meta.env.PROD;
